(ns frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.events
  (:require
   [common.util :as cu]))

;;EXPERIMENTAL, maybe add possibility to create a table from UI, if the excel data is missing
;; not used for now

#_(def default-table-configs
    {:column-font-style-row [nil nil]
     :highlight-row [nil nil]
     :alignment-row [nil nil]
     :pdf-column-width ["*" "*"]
     :headers [{:cols [nil nil]
                :header-type :header-type/heading
                :span-count 0}]
     :rows [(resolve-row-configurations [nil nil])]
     :column-style-row [nil nil]
     :table-style :table-style/alternating
     :heading-count 1})

#_(defn add-new-default-table!
    [state]
    (swap! state assoc :original-data default-table-configs))

;;TABLE EVENTS

(defn resolve-row-configurations
  [new-row-placeholder-data]
  ;;TODO Possibly make these values configurable from
  ;;the UI, when adding new rows to a table
  {:row-data new-row-placeholder-data
   :row-multipliers nil
   :pdf-linebreak nil
   :exceptional-value-row nil
   :allow-empty-row nil
   :empty-indicator-row "-"
   :row-comment nil
   :row-data-types :table-data-type/text
   :format-row nil
   :row-decimals nil
   :row-type nil
   :row-font-style nil
   :row-style nil
   :row-highlight nil})

(defn remove-column!
  [state index]
  (let [original-data (:original-data @state)
        original-headers (:headers original-data)
        original-rows (get-in original-data [:rows]) 
        pdf-column-widths (:pdf-column-width original-data)
        pdf-widths-row (:pdf-widths-row original-data)
        column-data-types (:column-data-types original-data)
        new-original-data (cond-> original-data
                            true
                            (assoc-in [:headers]
                                      (->> original-headers
                                           (mapv (fn [header]
                                                   (let [columns (:cols header)]
                                                     (assoc-in header [:cols]
                                                               (cu/vec-remove index columns)))))))
                            true
                            (assoc-in [:rows]
                                      (->> original-rows
                                           (mapv (fn [row]
                                                   (let [row-data (:row-data row)]
                                                     (assoc-in row [:row-data]
                                                               (cu/vec-remove index row-data)))))))
                            pdf-column-widths
                            (assoc-in [:pdf-column-width]
                                      (cu/vec-remove index pdf-column-widths))
                            pdf-widths-row
                            (assoc-in [:pdf-widths-row]
                                      (cu/vec-remove index pdf-widths-row))
                            column-data-types
                            (assoc-in [:column-data-types]
                                      (cu/vec-remove index column-data-types)))]
    (swap! state assoc :original-data new-original-data)))

(defn remove-row!
  [state row-idx]
  (when-not (->> @state
                 :data
                 (count)
                 (= 1))
    (swap! state update-in
           [:original-data :rows]
           (fn [data]
             (cu/vec-remove row-idx data)))))

(defn resolve-new-header-columns
  [original-headers index]
  (->> original-headers
       (mapv (fn [header]
               (let [columns (:cols header)]
                 (assoc-in header [:cols] (cu/vec-insert index "" columns)))))))

(defn resolve-new-row-data
  [original-rows index column-count]
  (->> original-rows
       (mapv (fn [row]
               (let [row-data (:row-data row)
                     row-data (if (= (count row-data) 1) ;;When some row data has only the row label
                                (vec (cons (first row-data) (repeat column-count nil)))
                                row-data)]
                 (assoc-in row [:row-data] (cu/vec-insert index nil row-data)))))))

(def allowed-table-data-types
  #{:table-data-type/text
    :table-data-type/number
    :table-data-type/currency
    :table-data-type/percentage
    :table-data-type/multiple
    :table-data-type/date})

(defn normalize-table-data-type
  [data-type]
  (if (contains? allowed-table-data-types data-type)
    data-type
    :table-data-type/text))

(defn add-column-to-index!
  [state index & [data-type]]
  (let [original-data (:original-data @state)
        headers (:headers original-data)
        rows (get-in original-data [:rows])
        pdf-column-widths (:pdf-column-width original-data)
        pdf-widths-row (:pdf-widths-row original-data)
        column-data-types (:column-data-types original-data)
        column-count (count (:cols (first headers)))
        resolved-type (normalize-table-data-type data-type)
        new-original-data (cond-> original-data
                            true
                            (assoc-in [:headers]
                                      (resolve-new-header-columns headers index))
                            true
                            (assoc-in [:rows]
                                      (resolve-new-row-data rows index column-count))
                            pdf-column-widths
                            (assoc-in [:pdf-column-width]
                                      (cu/vec-insert index "*" pdf-column-widths))
                            pdf-widths-row
                            (assoc-in [:pdf-widths-row]
                                      (cu/vec-insert index "*" pdf-widths-row))
                            (seq column-data-types)
                            (assoc-in [:column-data-types]
                                      (cu/vec-insert index resolved-type column-data-types)))]
    (swap! state assoc :original-data new-original-data)))

(defn add-row-to-index!
  [state index & [data-type]]
  (let [original-data (:original-data @state)
        original-headers (get-in original-data [:headers])
        original-rows (vec (get-in original-data [:rows]))
        column-count (count (:cols (first original-headers)))
        new-row-placeholder-data (if (zero? column-count)
                                   [nil nil]
                                   (vec (repeat column-count nil)))
        resolved-data-type (normalize-table-data-type data-type)
        new-original-data (-> original-data
                              (assoc-in [:rows]
                                        (cu/vec-insert index
                                                       (assoc (resolve-row-configurations
                                                               new-row-placeholder-data)
                                                              :row-data-types resolved-data-type)
                                                       original-rows)))]
    (swap! state assoc :original-data new-original-data)))

(defn update-heading!
  [state row-idx col-idx new-value]
  (swap! state assoc-in [:original-data :headers row-idx :cols col-idx] new-value))

(defn update-value!
  [state row-index col-index new-value]
  (let [new-original-data (-> (get-in @state [:original-data])
                              (assoc-in [:rows row-index :row-data col-index] new-value))]
    (swap! state assoc :original-data new-original-data)))

;;CHART EVENTS

(defn remove-column-multi-chart!
  [state index]
  (let [columns (:columns @state)
        series (:series @state)
        y-axis-configs (:y-axis-configs @state)]
    (reset! state
            (-> {}
                (assoc
                 :columns (cu/vec-remove index columns)
                 :series (->> series
                              (mapv (fn [series]
                                      (let [series-data (:data series)]
                                        (assoc-in series [:data]
                                                  (cu/vec-remove index series-data))))))
                 :y-axis-configs y-axis-configs)))))

(defn add-column-to-index-multi-chart!
  [state index]
  (let [columns (:columns @state)
        series (:series @state)
        y-axis-configs (:y-axis-configs @state)]
    (reset! state
            (-> {}
                (assoc
                 :columns (cu/vec-insert index "" columns)
                 :series (->> series
                              (mapv (fn [series]
                                      (let [series-data (:data series)]
                                        (assoc-in series [:data]
                                                  (cu/vec-insert index nil series-data))))))
                 :y-axis-configs y-axis-configs)))))

(defn update-series-data!
  [state row-index col-index new-value]
  (let [series (:series @state)
        new-series-data (-> series
                            (assoc-in [row-index :data (dec col-index)] new-value))]
    (swap! state assoc-in [:series] new-series-data)))
